import { useAuth0 } from '@auth0/auth0-react';
import Dialog from "@material-ui/core/Dialog";
import Pagination from "@material-ui/lab/Pagination";
import IconButton from "@mui/material/IconButton";
import downloadImg, { ReactComponent as Download } from "assets/icons/DownloadIcon.svg";
import eyeImg from "assets/icons/eyeIcon.svg";
import shareImg from "assets/icons/Share.svg";
import deleteImg from "assets/icons/Trush.svg";
import { Text } from "components";
import AlertDialog from 'components/Dialog';
import Filter from "components/Filter/Filter";
import NotAuthorized from 'components/NotAuthorized';
import MyTable from "components/Table";
import { formatDate } from "helper/dateFormat";
import FinanceService from "Lib/API/Finance";
import ShareDocumentsModal from 'pages/NewFinance/Documents/ShareDocumentsModal';
import ViewDocumentModal from 'pages/NewFinance/Documents/ViewDocumentModal';
import React, { useEffect, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { DocumentAction, DocumentContent, DocumentContentHead, DocumentContentPagination, DocumentContentTable, DocumentsContainer, DocumentsHeader } from "./Theme";

const filterList = [
  {
    name: "All",
    value: "all",
  },
  {
    name: "Statements",
    value: "tax_statement",
  },
  {
    name: "Tax Reports",
    value: "tax_report",
  },
  {
    name: "Invoices",
    value: "invoice",
  },
  {
    name: "Receipts",
    value: "receipt",
  },
];

const documentsType = {
  "tax_report": "Tax Report",
  "invoice": "Invoice",
  "tax_statement": "Statement",
  "receipt": "Receipt",
}



const Documents = ({accountId}) => {
  const { getAccessTokenSilently } = useAuth0();

  const [selectedFilter, setSelectedFilter] = useState("all");
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [viewDocumentId, setViewDocumentId] = useState(null);
  const [viewDocumentContent, setViewDocumentContent] = useState(null);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [documentRow, setDocumentRow] = useState(null);
  const [openConfirmAlert, setOpenConfirmAlert] = useState(false);
  const [documentId, setDocumentId] = useState(null);
  const [isFinanceActive, setIsFinanceActive] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);


  let orgInfo =
  localStorage.getItem("authorizedModules") !== undefined
    ? JSON.parse(localStorage.getItem("authorizedModules"))
    : [];


  const columns = [
		{
			field: "type",
			headerName: "TYPE",
			width: 250,
			align: "left",
			renderCell: (data) => {
				return <div className="row-data class-lits-table-cell">{documentsType[data?.row?.type] || data?.row?.type}</div>;
			},
		},
		{
			field: "date",
			headerName: "DATE / DATE RANGE",
			width: 250,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell" >
					{formatDate({date: data?.row?.date?.start, formatType: "defaultWithUTC"})} - 
          {data?.row?.updatedAt ? data?.row?.date.end !== null 
          ? formatDate({date: data?.row?.date?.end, formatType: "defaultWithUTC"}) : 	formatDate({date: data?.row?.date?.start, formatType: "defaultWithUTC"}) : ""}
				</div>
			),
		},
		{
			field: "lastSent",
			headerName: "LAST SENT",
			width: 250,
			// editable: true,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell" >
					{formatDate({date: data?.row?.lastSent, formatType: "defaultWithUTC"})}
				</div>
			),
		},
    {
			field: "createdAt",
			headerName: "CREATED DATE",
			width: 200,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell">
					{data?.row?.createdAt ? formatDate({ date: data?.row?.createdAt, formatType: "defaultWithUTC" }) : "-"}
				</div>
			),
		},
    {
			field: " ",
			headerName: "",
			width: 250,
			renderCell: (data) => (
				<DocumentAction className="row-data class-lits-table-cell">
         {(data?.row?.type === "tax_statement" || data?.row?.type === "tax_report") && (
            <IconButton size="large" onClick={() => {
              deleteDocumentHandler(data?.row?._id)
            }}>
              <img src={deleteImg} alt="trush" width={26} />
            </IconButton>
          )}
          <IconButton size="large" onClick={() => {
              viewDocumentHandler(data?.row?._id)
          }}>
            <img src={eyeImg} alt="eye" />
          </IconButton>
          
          <IconButton size="large" onClick={() => {
            downloadFileHandler(data?.row)
          }}>
            <img src={downloadImg} alt="download" />
          </IconButton>
          
          <IconButton size="large" onClick={() => {
            documentHandler(data?.row)
          }}>
            <img src={shareImg} alt="share" />
          </IconButton>
        </DocumentAction>
			),
		},
	];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "finance") {
        return setIsFinanceActive(item?.active);
      }
    });
  }, []);


  const deleteDocumentHandler = async (id) => {
    setOpenConfirmAlert(true)
    setDocumentId(id)
  }

  const confirmDeleteDocumentHandler =async () => {
    if(deleteLoading || !documentId) return;
    setDeleteLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.deleteDocument(token, documentId).then((response) => {
      toastr.success("Document deleted successfully");
      getDocumentsHandler();
    })
    .catch((error) => {
      toastr.error(error?.data?.message || "Something went wrong");
    }
    )
    .finally(() => {
      setOpenConfirmAlert(false);
      setDeleteLoading(false);
      setDocumentId(null);
    });
  }

  
  const viewDocumentHandler = (documentId) => {
    setViewDocumentId(documentId);
  }

  const downloadFileHandler = async (row) => {
    const { _id, name, type } = row;
    const token = await getAccessTokenSilently();
    await FinanceService.downloadDocument(token, _id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const currentDate = formatDate({ date: new Date(), formatType: "defaultWithUTC" });
      const fileType = type === "tax_statement" ? "Statement" : type.charAt(0).toUpperCase() + type.slice(1);
      const fileName = `${fileType}_${name.replaceAll(" ", "_")}_${currentDate}`
      link.setAttribute('download', `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }


 
  const documentHandler = (row) => {
    setOpenShareModal(true);
    setDocumentRow(row);
  }


  
  const getDocumentsHandler = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      filter: {
        accountId: accountId,
        type: selectedFilter === "all" ? undefined : selectedFilter,
      }
    }
    FinanceService.getAllDocuments(token, page + 1, 30, bodyData)
    .then((res) => {
      const result = res?.payload?.data;
      setList(result);
      setCount(res?.payload?.pagination?.count);
    })
    .catch((err) => {
      console.log("err: ", err);
      toastr.error("Error", err?.data?.message || "Something went wrong");
    })
    .finally(() => {
      setLoading(false);
    });
  }


  useEffect(() => {
    getDocumentsHandler();
  }, [selectedFilter,page]);


  const onFilterChange = (filter) => {
    setSelectedFilter(filter)
    setPage(0);
  }
  
  return isFinanceActive == false ? (
    <NotAuthorized title={"Finances"} />
  ) : (
   <DocumentsContainer>
      <DocumentsHeader>
        <Filter filterList={filterList} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} onFilterChange={onFilterChange}/>
      </DocumentsHeader>
      <DocumentContent className="family-table-container">
        <DocumentContentHead className="my-auto account_page-header">
          <Text className="sub-title pt-3" style={{ height: 44 }}>
            Documents
          </Text>
        </DocumentContentHead>
        <DocumentContentTable className="home-table-container mt-0">
          <MyTable
            className="family-table education-account-table"
            rows={list}
            columns={columns}
            pageSize={30}
            loading={loading}
            rowHeight={70}
          />
			</DocumentContentTable>
      <DocumentContentPagination className="pagination-custom" style={{ marginTop: "20px" }}>
				<Pagination
					count={Math.ceil(count / 30)}
					color="primary"
					variant="outlined"
					onChange={(event, value) => {
						setPage(value - 1);
					}}
          page={page + 1}
				/>
			</DocumentContentPagination>
      </DocumentContent>
      <Dialog
        open={viewDocumentId !== null || viewDocumentContent !== null}
        onClose={() => {
          setViewDocumentId(null);
          setViewDocumentContent(null);
        }}
        PaperProps={{
          style: {
            width: "888px",
            height: "90vh",
            overflow: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >

        <ViewDocumentModal
          documentHtmlContent={viewDocumentContent ? viewDocumentContent : null}
          documentId={viewDocumentId ? viewDocumentId : null}
          closeModal={() => {
            setViewDocumentId(null);
            setViewDocumentContent(null);
          }}
        />
      </Dialog>
      <Dialog
        open={openShareModal}
        onClose={() => {
          setOpenShareModal(false);
        }}
        PaperProps={{
          style: {
            width: "888px",
            height: "637px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <ShareDocumentsModal
          closeModal={() => {
            setOpenShareModal(false);
          }}
          documentsIds={[documentRow?._id]}
          documentType={documentRow?.type}
          defaultEmail={documentRow?.account_details?.defaultEmails || []}
          type="Document"
        />
      </Dialog>
      <AlertDialog
          open={openConfirmAlert}
          onDecline={() => {
            setOpenConfirmAlert(false);
          }}
          onAccept={() => {
            confirmDeleteDocumentHandler()
          }}
          title={`Are you sure?`}
          description={`Do you want to delete this document?`}
          disabled={deleteLoading}
        />
   </DocumentsContainer>
  )
}

export default Documents